import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HtmlPreviewService } from '@fi-shared/fi-print-download/html-preview.service';
import { FiPrintDownloadComponent } from '@fi-shared/fi-print-download/fi-print-download.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiPrintDownloadService } from '@fi-shared/fi-print-download/fi-print-download.service';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule, MatIconModule, MatButtonModule],
    declarations: [FiPrintDownloadComponent],
    providers: [HtmlPreviewService, FiPrintDownloadService],
    exports: [FiPrintDownloadComponent],
})
export class FiPrintDownloadModule {}
